export default "__VITE_ASSET__8810e208__"